const back_blue = "data:image/svg+xml,%3csvg%20width='9'%20height='15'%20viewBox='0%200%20600%201010'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='%231437FF'%20d='M595%2084q0%2013-10%2023l-393%20393%20393%20393q10%2010%2010%2023t-10%2023l-50%2050q-10%2010-23%2010t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10%2023-10t23%2010l50%2050q10%2010%2010%2023z'/%3e%3c/svg%3e";
export {
  back_blue as default
};
//# sourceMappingURL=back_blue.svg.es.js.map
